import React, {Component} from 'react';
// import Control from 'material/controls/control/control';

import injectSheet from 'react-jss';
import styles from 'material/controls/controls_styles';

class Controls extends Component {
    constructor(props) {
        super(props);
        this.state ={
            selected: this.props.initialValue
        }
    };
    // handleSelect = (control)=>{
    //     //this.props.reducerMethod(control) example if connected to redux
    //     this.setState({selected: control})
    // };
    //
    // renderControls = ()=>{
    //  return this.props.controls.map((item,i)=>{
    //       return <Control selected={this.state.selected === item} value={item} key={i} handleSelect={this.handleSelect} />
    //   })
    // };

    render() {
        return (
            <div className={`controls ${this.props.classes.controls}`} >
                {this.props.children}
            </div>
        )
    }
}

export default injectSheet(styles)(Controls)